import { connect } from 'react-redux'
import Chart from './Chart.component'

const mapStateToProps = state => {
  return {
    agentId: state.agent.active?.agentId,
    organisationId: state.organisation?.active?.organisationId,
    token: state.session?.token
  }
}

const mapDispatchToProps = () => {return {}}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Chart)
